<nz-divider
    *ngIf="!!this.options.displayName"
    class="no-margin"
    nzPlain="true"
    [nzText]="text"
    nzOrientation="left"
>
    <ng-template #text>
        <div class="sider-divider-text">
            {{ this.options.displayName.toUpperCase() }}
        </div>
    </ng-template>
</nz-divider>
<div style="width: 100%">
    <input
        nz-input
        [placeholder]="!!this.options.displayName"
        [(ngModel)]="dataModelValue"
        (ngModelChange)="onViewModelChange($event)"
        type="string"
        nzSize="small"
    />
</div>
